import { useMutation } from "@apollo/client";
import { useState } from "react";
import { UPDATE_MEDIA_FOLDER } from "../../../graphql/mutation/mediaFolders";

const Input = ({ id, name, setIsEditing }: { id: number, name?: string, setIsEditing: Function }) => {
  const [folderName, setFolderName] = useState(name || 'New Folder')

  const [updateMediaFolder, { loading }] = useMutation(UPDATE_MEDIA_FOLDER);

  const handleUpdate = async () => {
    try {
      if (folderName && folderName !== name) {
        await updateMediaFolder({
          variables: {
            id,
            name: folderName
          }
        });
      }
      setIsEditing(false)
    } catch (error) {
      console.log(error, 'error----')
      setIsEditing(false)
    }
  }

  return (
    <div className="relative rounded w-full">
      <input
        type="text"
        name="name"
        id="folderName"
        className="w-full rounded border-0 p-1.5 pr-10 sm:text-sm sm:leading-6"
        placeholder={name}
        value={folderName.trimStart()}
        onChange={(e) => setFolderName(e.target.value?.trimStart())}
        autoFocus={true}
        disabled={loading}
        tabIndex={0}
        onKeyDown={async (e) => {
          if (e.key === 'Enter') {
            await handleUpdate()
          } else if (e.key === 'Escape') {
            setIsEditing(false)
          }
        }}
      onBlur={async() => {
        await handleUpdate()
      }}
      />
      {
        !folderName &&
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="icon icon-tabler icon-tabler-exclamation-circle" width="16" height="16" viewBox="0 0 24 24" stroke-width="1.5" stroke="red" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M12 9v4" />
            <path d="M12 16v.01" />
          </svg>
        </div>
      }
    </div>
  )
};

export default Input;